import React from "react";
import PracticeAreas from "@/components/PracticeAreas";
import Difference from "@/components/Difference";

export default function PracticePage() {
  return (
    <div className="pt-24" data-testid="page-practice">
      <PracticeAreas />
      <Difference />
    </div>
  );
}
